import Vue from 'vue';
import Router from 'vue-router';
import GlobalLoginLayout from '../../../global/layouts/GlobalLoginLayout';
import loginRoutes from './login';

import UserResourcesLayout from '../../../global/layouts/UserResourcesLayout';
import userResourceRoutes from './user-resources';

import ParentAppLayout from '../layouts/ParentAppLayout';
import parentRoutes from './parent';
import clientBillingRoutes from './client-billing';
import parentPermissionRoutes from './parent-permissions';
import store from '../store';

import loginGuard from './guard/loginGuard.js'

const P404NotFound = () => import(/* webpackPrefetch: true */ './../pages/P404NotFoundPage');
Vue.use(Router);

const router = new Router({
  saveScrollPosition: false,
  // hashbang: false,
  mode: 'history',

  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },

  routes: [
    {
      component: UserResourcesLayout,
      path: '',
      children: [
        ...userResourceRoutes,
        ...clientBillingRoutes,
        ...parentPermissionRoutes,
      ],
    },

    {
      component: ParentAppLayout,
      path: '/parent',
      children: [
        ...parentRoutes,
      ],
    },

    {
      component: GlobalLoginLayout,
      path: '/',
      children: [
        ...loginRoutes,
        {
          path: '**',
          component: P404NotFound,
          name: 'P404NotFound',
          meta: {
            title: 'Page not found',
          },
        },
      ],
    },

  ],
});


router.beforeEach((to, from, next) => {
  if (loginGuard.runGuard(to)) {
    store().dispatch('UPDATE_USER').then((res) => {
      if (res.code === 200) {
        next();
      } else {
        // using href to flush the store
        window.location.href = '/logout';
      }
    });
  } else {
    next();
  }
});

const defaultTitle = 'ClassForKids';
router.afterEach((to) => {
  Vue.nextTick(() => {
    document.title = to.meta.title || defaultTitle;
  });
});


export default router;
